// src/pages/PainelAgendamentos/MenuAgendamento.jsx
import { useState } from "react";
import { Save, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function MenuAgendamento({
  onSalvar,
  onCancelar,
  status,
  setStatus,
}) {
  const [open, setOpen] = useState(false);

  // 🔹 Opções atualizadas (sem "Finalizado")
  const options = ["Pendente", "Concluída", "Cancelada", "Reagendado"];

  const statusColor = {
    Pendente: "text-yellow-500",
    Concluída: "text-green-600",
    Cancelada: "text-red-600",
    Reagendado: "text-blue-600",
  };

  return (
    <motion.div
      initial={{ x: 50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col gap-3 items-center justify-between h-full w-full"
    >
      {/* Botões */}
      <div className="flex flex-col gap-3 w-full">
        {/* Botão Salvar */}
        <button
          onClick={onSalvar}
          className="flex items-center justify-center gap-2 px-3 py-2 rounded-md text-white font-medium 
                     shadow-sm transition hover:scale-105"
          style={{ backgroundColor: "#16a34a" }}
        >
          <Save size={16} />
          Salvar
        </button>

        {/* Botão Cancelar */}
        <button
          onClick={onCancelar}
          className="flex items-center justify-center gap-2 px-3 py-2 rounded-md text-white font-medium 
                     shadow-sm transition hover:scale-105"
          style={{ backgroundColor: "#b50000" }}
        >
          <X size={16} />
          Cancelar
        </button>
      </div>

      {/* Campo Status no rodapé */}
      <div className="w-full mt-4 relative">
        <div
          onClick={() => setOpen((prev) => !prev)}
          className={`w-full border-0 border-b border-gray-400 px-1 py-2 text-lg cursor-pointer bg-transparent text-center font-bold ${
            status ? statusColor[status] : "text-gray-600"
          }`}
        >
          {status || "Status"}
        </div>

        <AnimatePresence>
          {open && (
            <motion.ul
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.2 }}
              className="absolute left-0 right-0 bottom-full bg-white border border-gray-300 rounded-md shadow-md z-10"
            >
              {options.map((opt) => (
                <li
                  key={opt}
                  onClick={() => {
                    setStatus(opt);
                    setOpen(false);
                  }}
                  className={`px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer ${
                    status === opt ? "font-semibold text-blue-600" : ""
                  }`}
                >
                  {opt}
                </li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
